import { IsArray, IsInt, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { CaptureValueType } from '../../enum';

export class CaptureSettingsMerchantSaveDto {
  @IsNotEmpty()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => CaptureSettingsMerchantSaveTreeNodeDto)
  nodes: CaptureSettingsMerchantSaveTreeNodeDto[];
}

export class CaptureSettingsMerchantSaveTreeNodeDto {
  @IsNotEmpty()
  @IsNotEmpty()
  id: number;

  @IsOptional()
  @IsInt()
  parentId?: number;

  @IsOptional()
  merchantSettingValue?: string;

  @IsOptional()
  @IsInt()
  merchantSettingId?: number;

  @IsNotEmpty()
  @IsString()
  valueType: CaptureValueType;

  // --- Recursive Validation Logic ---
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => CaptureSettingsMerchantSaveTreeNodeDto)
  children?: CaptureSettingsMerchantSaveTreeNodeDto[];
}
